// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header-affix .ant-affix {\n  background: #fff;\n  box-shadow: 0 1px 10px rgb(0 0 0 / 10%);\n}", "",{"version":3,"sources":["webpack://src/components/pages/admin/evaluate/Assessment.page.style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uCAAuC;AACzC","sourcesContent":[".page-header-affix .ant-affix {\n  background: #fff;\n  box-shadow: 0 1px 10px rgb(0 0 0 / 10%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
